import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer/decorators";
import { EntrySelectionRequestModel, IEntrySelectionRequest } from "./entrySelectionRequest";
let EntryReportModel = /** @class */ (() => {
    var _a;
    class EntryReportModel {
        constructor() {
            this.highlightId = null;
            this.reportTemplateId = null;
            this.startDate = null;
            this.endDate = null;
            this.createdStartDate = null;
            this.createdEndDate = null;
            this.entrySelection = new EntrySelectionRequestModel();
        }
    }
    __decorate([
        Type(() => EntrySelectionRequestModel),
        __metadata("design:type", typeof (_a = typeof IEntrySelectionRequest !== "undefined" && IEntrySelectionRequest) === "function" ? _a : Object)
    ], EntryReportModel.prototype, "entrySelection", void 0);
    return EntryReportModel;
})();
export { EntryReportModel };
export default class EntryReport extends EntryReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
